/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { arrayOf, entity, enumeration, subentity } from '@gh/core-data';
import {
  DashboardChartType,
  MonthlySalesSlabsDto,
  MonthlySalesSlabsValue,
  MonthlySalesSlabsYValue,
} from '../dto';

export const MonthlySalesSlabsMapper = entity<MonthlySalesSlabsDto>({
  values: arrayOf(subentity<MonthlySalesSlabsValue>({
    yAxisValues: arrayOf(subentity<MonthlySalesSlabsYValue>({
      type: enumeration(DashboardChartType),
    })),
  })),
});
